import {
  buildCrossFloorClassicRoute as buildSharedCrossFloorClassicRoute,
  footprintPolygonsForLevel as sharedFootprintPolygonsForLevel
} from '@alpinehomeair/common';
import { LevelType, PositionType } from 'data/types';
import { GridSpace } from 'utils/lineset-geometry';
import { toLinesetLevel } from 'utils/lineset-level-adapter';

export function footprintPolygonsForLevel(
  structure: LevelType[],
  levelIndex: number
): PositionType[][] {
  if (levelIndex < 0) return [];
  return sharedFootprintPolygonsForLevel(toLinesetLevel(structure[levelIndex]));
}

export function buildCrossFloorClassicRoute(
  condenserCenter: PositionType,
  airHandlerCenter: PositionType,
  condenserSpaces: GridSpace[],
  airHandlerSpaces: GridSpace[],
  condenserFootprints: PositionType[][],
  airHandlerFootprints: PositionType[][],
  targetSpaceId: string | null,
  preferShortestTotalEntry: boolean
): { condenserPath: PositionType[]; airHandlerPath: PositionType[] } {
  return buildSharedCrossFloorClassicRoute(
    condenserCenter,
    airHandlerCenter,
    condenserSpaces,
    airHandlerSpaces,
    condenserFootprints,
    airHandlerFootprints,
    targetSpaceId,
    preferShortestTotalEntry
  );
}
